"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateDeliveryCommentQuery = void 0;
var _axios = require("@ori/axios");
var _checkoutUtils = require("@ori/checkout-utils");
var _fetching = require("@ori/fetching");
var _react = require("react");
var _logger = require("../logger");
// TODO: to be rewritten, fragile code
const useUpdateDeliveryCommentQuery = commentToUpdate => {
  const [comment, setComment] = (0, _react.useState)(commentToUpdate);
  let isSwrActive = false;
  const basePath = '/system/ajax/DeliverySelection/UpdateDeliveryComment';
  const fetcher = async deliveryComment => {
    try {
      const {
        data
      } = await _axios.axios.put(`${basePath}`, {
        comment: deliveryComment
      });
      isSwrActive = false;
      setComment(deliveryComment);
      (0, _logger.logDebug)('Result', data);
      return data;
    } catch (error) {
      (0, _checkoutUtils.showErrorNotification)();
      _logger.mainLogger.error(error, {
        action: 'useUpdateDeliveryCommentQuery'
      });
      return null;
    }
  };
  const {
    mutate
  } = (0, _fetching.useSWR)(
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- no it is not
  isSwrActive ? basePath : null, fetcher);
  async function updateDeliveryComment(deliveryComment) {
    isSwrActive = true;
    await mutate(fetcher(deliveryComment), {
      optimisticData: deliveryComment,
      rollbackOnError: true,
      populateCache: true,
      revalidate: false
    });
  }
  return {
    comment,
    updateDeliveryComment
  };
};
exports.useUpdateDeliveryCommentQuery = useUpdateDeliveryCommentQuery;